import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { ThemeProvider } from '@mui/material'
import theme from './theme'
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { HelmetProvider } from 'react-helmet-async'

const gtmParams = {
  id: import.meta.env.VITE_GTM_ID,
  nonce: 'zy9ekYQ4S4RjDOUd8ZcUFdKinTHPl0cWsr2fWQK5Ji0='
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GTMProvider state={gtmParams}>
      <ThemeProvider theme={theme}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </ThemeProvider>
    </GTMProvider>
  </StrictMode>,
)
